/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */

import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { iconType } from 'types';

const getWidth = (originalWidth, originalHeight, currentHeight) => Math.round(currentHeight * (originalWidth / originalHeight));

const Icon = ({
  icon, color, height, theme, modifiers,
}) => {
  const isInverseModifierActive = typeof modifiers === 'string'
    ? modifiers === 'inverse'
    : modifiers.includes('inverse');
  const iconColor = color
    || (isInverseModifierActive ? theme.colors.baseInverse : theme.colors.base);

  // if the icon starts with 'fa' assumes a font-awesome icon
  const isFontAwesome = icon.indexOf('fa') !== -1
  if (isFontAwesome) {
    return (
      <i className={icon} style={{ fontSize: `${height}px`, color: iconColor }} />
    )
  }

  switch (icon) {
  case 'search':
    return (
      <svg
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <path
            d="M9.96 2.964c.934 0 1.832.179 2.695.536a6.975 6.975 0 0 1 2.284 1.526c.66.66 1.17 1.422 1.527 2.285.357.863.536 1.761.536 2.695 0 .934-.179 1.832-.536 2.695a6.975 6.975 0 0 1-1.527 2.284 6.975 6.975 0 0 1-2.284 1.527 6.975 6.975 0 0 1-2.695.536 6.975 6.975 0 0 1-2.695-.536 6.975 6.975 0 0 1-2.285-1.527 6.975 6.975 0 0 1-1.526-2.284 6.975 6.975 0 0 1-.536-2.695c0-.934.179-1.832.536-2.695A6.975 6.975 0 0 1 4.98 5.026 6.975 6.975 0 0 1 7.265 3.5a6.975 6.975 0 0 1 2.695-.536z"
            stroke={iconColor}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.668 15.5l6.663 5.877"
            stroke={iconColor}
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </g>
      </svg>
    );
  case 'section':
    return (
      <svg
        width={getWidth(80, 69, height)}
        height={height}
        viewBox="0 0 80 69"
        xmlns="http://www.w3.org/2000/svg"
        fill={iconColor}
      >
        <path
          d="M8 0h64a8 8 0 0 1 8 8v53a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8zm3 23v34h58V23H11z"
          fillRule="evenodd"
        />
      </svg>
    );
  case 'add':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        fill={iconColor}
      >
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    );
  case 'nav':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        fill={iconColor}
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
      </svg>
    );
  case 'link':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        fill={iconColor}
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" />
      </svg>
    );
  case 'chevron-right':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        fill={iconColor}
      >
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    );
  case 'chevron-left':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        fill={iconColor}
      >
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    );
  case 'close':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        fill={iconColor}
      >
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
        <path fill="none" d="M0 0h24v24H0z" />
      </svg>
    );
  case 'logout':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
      >
        <g fill={iconColor} fillRule="evenodd">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
        </g>
      </svg>
    );
  case 'expand-more':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
      >
        <g fill={iconColor} fillRule="evenodd">
          <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </g>
      </svg>
    );
  case 'expand-less':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
      >
        <g fill={iconColor} fillRule="evenodd">
          <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </g>
      </svg>
    );
  case 'description':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        fill={iconColor}
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
      </svg>
    );
  case 'page':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
      >
        <g fill="none" fillRule="evenodd">
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            fill={iconColor}
            fillRule="nonzero"
            d="M14 1H6.001c-1.165.072-2.053 1.054-1.99 2.2l-.009 17.6c-.064 1.146.824 2.128 1.99 2.2h12.005c1.167-.072 2.058-1.052 2-2.2V7.6L13.998 1zM6 21V3h7v5.625h5V21H6z"
          />
        </g>
      </svg>
    );
  case 'edit':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        fill={iconColor}
      >
        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    );
  case 'arrow-back':
    return (
      <svg
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <g stroke={iconColor} strokeLinecap="round" strokeWidth="2.864">
            <path
              strokeLinejoin="round"
              d="M11.234 2.95l-8.753 8.961 8.753 8.961"
            />
            <path d="M4.864 12.45h17.181" />
          </g>
        </g>
      </svg>
    );
  case 'arrow-forward':
    return (
      <svg
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        transform="rotate(180)"
      >
        <g fill="none" fillRule="evenodd">
          <g stroke={iconColor} strokeLinecap="round" strokeWidth="2.864">
            <path
              strokeLinejoin="round"
              d="M11.234 2.95l-8.753 8.961 8.753 8.961"
            />
            <path d="M4.864 12.45h17.181" />
          </g>
        </g>
      </svg>
    );
  case 'arrow-right':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        fill={iconColor}
      >
        <path d="M10 17l5-5-5-5v10z" />
        <path fill="none" d="M0 24V0h24v24H0z" />
      </svg>
    );
  case 'arrow-down':
    return (
      <svg
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        transform="rotate(90)"
      >
        <g fill="none" fillRule="evenodd">
          <g stroke={iconColor} strokeLinecap="round" strokeWidth="2.864">
            <path
              strokeLinejoin="round"
              d="M11.234 2.95l-8.753 8.961 8.753 8.961"
            />
            <path d="M4.864 12.45h17.181" />
          </g>
        </g>
      </svg>
    );
  case 'arrow-up':
    return (
      <svg
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        transform="rotate(270)"
      >
        <g fill="none" fillRule="evenodd">
          <g stroke={iconColor} strokeLinecap="round" strokeWidth="2.864">
            <path
              strokeLinejoin="round"
              d="M11.234 2.95l-8.753 8.961 8.753 8.961"
            />
            <path d="M4.864 12.45h17.181" />
          </g>
        </g>
      </svg>
    );
  case 'update':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        fill={iconColor}
      >
        <defs>
          <path id="a" d="M0 0h24v24H0V0z" />
        </defs>
        <clipPath id="b">
          <use xlinkHref="#a" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#b)"
          d="M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1a6.875 6.875 0 0 0 0 9.79 7.02 7.02 0 0 0 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58a8.987 8.987 0 0 1 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z"
        />
      </svg>
    );
  case 'arrow-upward':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        fill={iconColor}
      >
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z" />
      </svg>
    );
  case 'arrow-downward':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        fill={iconColor}
      >
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z" />
      </svg>
    );
  case 'ua':
    return (
      <svg
        width={getWidth(208, 220, height)}
        height={height}
        fill={iconColor}
        viewBox="0 0 208 220"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M177.65 186.58a4.69 4.69 0 0 1-4.75 4.58h-39.58a20.72 20.72 0 0 0-18.18 11 9.23 9.23 0 0 1-8 4.55h-3.44a9.79 9.79 0 0 1-8.38-5 20.14 20.14 0 0 0-17.78-10.52H34.66a4.69 4.69 0 0 1-4.75-4.58v-56.5a4.58 4.58 0 0 1 4.48-4.73h43.12a20.7 20.7 0 0 1 18.18 11 9.22 9.22 0 0 0 8 4.54h3.44a9.76 9.76 0 0 0 8.38-5 20.15 20.15 0 0 1 17.78-10.52h39.79a4.56 4.56 0 0 1 4.6 4.58l-.03 56.6zm5-169a8.34 8.34 0 0 0-7.81 3.03l-22.11 26.93a18.22 18.22 0 0 1-12.7 5.1c-10 0-18.24-7.92-18.24-17.69 0-18.56-14.39-33.44-32.93-34.93a3.14 3.14 0 0 0-3.18 3.15v31.78a17.75 17.75 0 0 1-17.91 17.69 18.58 18.58 0 0 1-12.85-5.1L32.8 20.61a8.32 8.32 0 0 0-7.8-3.03C10.731 19.537.156 31.819.34 46.22V191c0 16 13.25 29 29.58 29h147.8c16.34 0 29.59-13 29.59-29V46.23c.18-14.4-10.393-26.679-24.66-28.64v-.01z" />
      </svg>
    );
  case 'logo-ua':
    return (
      <svg
        width={getWidth(916, 220, height)}
        height={height}
        fill={iconColor}
        viewBox="0 0 916 220"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M177.65 186.58a4.69 4.69 0 0 1-4.75 4.58h-39.58a20.72 20.72 0 0 0-18.18 11 9.23 9.23 0 0 1-8 4.55h-3.44a9.79 9.79 0 0 1-8.38-5 20.14 20.14 0 0 0-17.78-10.52H34.66a4.69 4.69 0 0 1-4.75-4.58v-56.5a4.58 4.58 0 0 1 4.48-4.73h43.12a20.7 20.7 0 0 1 18.18 11 9.22 9.22 0 0 0 8 4.54h3.44a9.76 9.76 0 0 0 8.38-5 20.15 20.15 0 0 1 17.78-10.52h39.79a4.56 4.56 0 0 1 4.6 4.58l-.03 56.6zm5-169a8.34 8.34 0 0 0-7.81 3.03l-22.11 26.93a18.22 18.22 0 0 1-12.7 5.1c-10 0-18.24-7.92-18.24-17.69 0-18.56-14.39-33.44-32.93-34.93a3.14 3.14 0 0 0-3.18 3.15v31.78a17.75 17.75 0 0 1-17.91 17.69 18.58 18.58 0 0 1-12.85-5.1L32.8 20.61a8.32 8.32 0 0 0-7.8-3.03C10.731 19.537.156 31.819.34 46.22V191c0 16 13.25 29 29.58 29h147.8c16.34 0 29.59-13 29.59-29V46.23c.18-14.4-10.393-26.679-24.66-28.64v-.01zM262.29 146.26h-4.22v10.37h-6v3.55h6v23.63c-.07 5.89 1.87 7.77 7.5 7.77 1.27 0 2.47-.13 3.75-.13v-3.62c-1.202.133-2.41.2-3.62.2-3-.2-3.41-1.81-3.41-4.55v-23.29h7v-3.55h-7v-10.38zM275 125.37h7.5V90.76h-7.63v20.09c0 5.36-2.14 9.44-8.51 9.44-4.14 0-6.63-2.2-6.63-8.3V90.76h-7.63v22c0 9 3.88 13.59 12.92 13.59a11.63 11.63 0 0 0 9.84-5.76l.14 4.78zM707.81 164.74l-.13-8.1h-3.88v34.54h4.2v-18.41c0-7.16 5.22-12.78 12.86-12.38v-4.22a12.76 12.76 0 0 0-13.05 8.57M289.39 155.63c-4.88 0-9.51 2.81-11 7l-.13-19.21H274v47.79h4.21V171c.13-6.76 4.15-11.85 10.84-11.85 6.69 0 8.77 4.49 8.77 10.44v21.55H302V169c0-8.23-2.94-13.32-12.65-13.32M326.43 90.77h7.63v34.61h-7.63zM816.67 105c.2-5.15 3.81-9.17 9.1-9.17 5.29 0 8.44 4.35 8.7 9.17h-17.8zm9.1-15.2c-10.3 0-16.73 8.44-16.73 18.28 0 10.64 6.09 18.21 16.94 18.21 7.56 0 14-4.22 15.66-11.78h-7.24c-1.34 3.82-4 5.76-8.43 5.76-6.36 0-9.3-4.82-9.3-10.24h25.43c1.27-10.38-5.43-20.22-16.34-20.22l.01-.01zM311.9 103.62v21.76h7.63v-23.77c0-7.77-4.76-11.78-12.25-11.78A12.4 12.4 0 0 0 296.51 96l-.13-5.22h-7.23v34.61h7.63V105c0-5.09 3.28-9.11 8.37-9.11 4.48 0 6.63 2.35 6.76 7.77M356.64 188.63c-8.1 0-12.12-7.36-12.12-14.72s4-14.73 12.12-14.73 12.12 7.36 12.12 14.73-4 14.72-12.12 14.72m0-33c-10.58 0-16.34 8.37-16.34 18.28 0 9.91 5.76 18.27 16.34 18.27S373 183.81 373 173.91s-5.75-18.28-16.33-18.28M846.78 90.77h7.63v34.61h-7.63zM381.94 164.74l-.13-8.1h-3.88v34.54h4.21v-18.41c0-7.16 5.22-12.78 12.86-12.38v-4.22a12.76 12.76 0 0 0-13.05 8.57M322.51 159.18c6.83 0 10.78 6 11 12.32h-22.37c.67-6.29 4.48-12.32 11.38-12.32m0-3.55c-11 0-15.59 9.17-15.59 18.28 0 9.84 4.62 18.27 15.59 18.27 8.7 0 13.26-4.55 15.07-12.38h-4.22c-1.34 5.22-4.69 8.84-10.85 8.84-8.1 0-11.31-7.43-11.38-13.59h26.58c.33-9.71-4.09-19.41-15.2-19.41M610.69 95.85c5.15 0 8.44 4.35 8.7 9.17h-17.8c.2-5.16 3.81-9.17 9.1-9.17m.2 30.46c7.56 0 14-4.22 15.66-11.78h-7.23c-1.34 3.82-4 5.76-8.43 5.76-6.36 0-9.3-4.82-9.3-10.24H627c1.27-10.38-5.43-20.22-16.34-20.22-10.3 0-16.73 8.44-16.73 18.28 0 10.64 6.09 18.21 16.94 18.21M881.64 90a17.53 17.53 0 0 0-2.88-.2c-4.69 0-9.23 4-10.11 7.63l-.13-6.7h-7.16v34.61H869v-16.43c0-7.64 4.15-11.85 9.37-11.85 1.1.047 2.195.16 3.28.34l-.01-7.4zM571.74 95.85c5.89 0 9.57 4.55 9.57 12.19 0 6-2.88 12.25-9.71 12.25-6.63 0-9.58-5.89-9.58-11.85 0-6.22 2.54-12.58 9.71-12.58m-1.14 30.46c4.35 0 8.7-1.68 10.71-5.62l.13 4.68h7.23v-47.8H581v17.67c-2.48-3.82-7.29-5.43-11.65-5.43-7.56 0-15 5.49-15 18 0 10.38 5.29 18.48 16.2 18.48M762.8 113.73c0 4.81-5.22 6.56-8.57 6.56-2.68 0-7-1-7-4.42 0-4 3-5.22 6.23-5.76 3.23-.54 7-.54 9.37-2.07l-.03 5.69zm-9.91-8.3c-6.43.73-13.32 2.14-13.32 10.78 0 6.76 5.62 10.11 11.85 10.11 4.09 0 9-1.28 12-4.22.61 3.15 2.81 4.22 5.89 4.22a19.16 19.16 0 0 0 4.82-.87v-5.29a10.57 10.57 0 0 1-1.87.13c-1.4 0-1.8-.73-1.8-2.61V99.87c0-7.29-7.1-10-13.86-10-7.63 0-15.2 2.61-15.73 11.52h7.63c.34-3.75 3.35-5.49 7.63-5.49 3.08 0 7.16.74 7.16 4.69 0 4.48-4.88 3.88-10.37 4.89l-.03-.05zM898.23 120.29c-6.82 0-9.84-6.23-9.84-12.25s3-12.19 9.84-12.19 9.84 6.22 9.84 12.19-3 12.25-9.84 12.25m0-30.46c-11.11 0-17.47 7.63-17.47 18.21 0 10.58 6.36 18.28 17.47 18.28s17.47-7.63 17.47-18.28c0-10.65-6.36-18.21-17.47-18.21M326.43 77.58h7.63v7.23h-7.63zM417.9 108.91c0-7.64 4.15-11.85 9.37-11.85a27.2 27.2 0 0 1 3.28.34V90a17.59 17.59 0 0 0-2.88-.2c-4.69 0-9.24 4-10.11 7.63l-.13-6.7h-7.17v34.61h7.63l.01-16.43zM496.31 95.85c5.89 0 9.57 4.55 9.57 12.19 0 6-2.88 12.25-9.71 12.25-6.63 0-9.57-5.89-9.57-11.85 0-6.22 2.54-12.58 9.71-12.58m-1.13 30.46c4.35 0 8.7-1.68 10.71-5.62l.13 4.68h7.23v-47.8h-7.63v17.67c-2.47-3.82-7.29-5.43-11.64-5.43-7.56 0-15 5.49-15 18 0 10.38 5.29 18.48 16.2 18.48M358.75 125.37l12.38-34.61h-7.9l-8.43 26.58-8.91-26.58h-8.29l12.58 34.61zM466.06 77.58h7.63v7.23h-7.63zM466.06 90.77h7.63v34.61h-7.63zM846.78 77.57h7.63v7.23h-7.63zM557.18 159.18c6.82 0 10.78 6 11 12.32H545.8c.67-6.29 4.49-12.32 11.38-12.32m0-3.55c-11 0-15.6 9.17-15.6 18.28 0 9.84 4.62 18.27 15.6 18.27 8.7 0 13.25-4.55 15.06-12.38H568c-1.34 5.22-4.68 8.84-10.84 8.84-8.1 0-11.31-7.43-11.38-13.59h26.57c.34-9.71-4.08-19.41-15.19-19.41M607.62 143.38h4.22v6.75h-4.22zM607.62 156.64h4.22v34.54h-4.22zM532.36 156.64h4.22v34.54h-4.22zM784 156.63h-5.29l-9.64 13.12-9.84-13.12H754l12.38 16.6-12.7 17v.65l-.55.09-.13.18h5.22l10.64-14.53 10.84 14.53h5.3l-13.45-18zM532.36 143.38h4.22v6.75h-4.22zM397.73 156.64h4.22v34.54h-4.22zM683 188.63c-9 0-12.12-7.56-12.12-14.72 0-7.83 2.81-14.73 12.12-14.73 8 0 11.31 7.56 11.31 14.73 0 7.17-3.28 14.72-11.31 14.72m0-33c-5.56 0-10.37 2.88-12.32 7.56l-.13-6.56h-3.88V204h4.22v-19.39c1.94 5 7 7.56 12.12 7.56 10.51 0 15.53-8.5 15.53-18.27s-5-18.28-15.53-18.28M703.38 95.85c5.16 0 8.44 4.35 8.7 9.17h-17.8c.2-5.15 3.81-9.17 9.1-9.17m15.87 18.68H712c-1.34 3.82-4 5.76-8.44 5.76-6.36 0-9.3-4.82-9.3-10.24h25.44c1.28-10.38-5.43-20.22-16.34-20.22-10.3 0-16.73 8.44-16.73 18.28 0 10.64 6.09 18.21 16.94 18.21 7.56 0 14-4.22 15.67-11.78M664.29 120.29c-6.63 0-9.57-5.89-9.57-11.85 0-6.22 2.54-12.58 9.71-12.58 5.89 0 9.57 4.55 9.57 12.19 0 6-2.88 12.25-9.71 12.25m9.71.4l.13 4.69h7.23V77.58h-7.63v17.67c-2.47-3.82-7.29-5.43-11.64-5.43-7.57 0-15 5.49-15 18 0 10.37 5.29 18.47 16.2 18.47 4.36 0 8.7-1.68 10.71-5.62M634.86 172.23l-5.63-1.23c-2.88-.74-7.16-2.08-7.16-5.83 0-4.48 4.42-6 8.17-6 4.82 0 8.83 2.35 9 7.56h4.21c-.27-7.5-5.76-11.11-12.65-11.11-6.09 0-13 2.68-13 9.71 0 5.89 4.15 7.77 9.64 9.24l5.42 1.2c3.81.94 7.56 2.28 7.56 6.29 0 4.82-5.49 6.56-9.44 6.56-5.62 0-9.84-2.95-10.18-8.63h-4.22c.67 8.43 6.16 12.18 14.19 12.18 6.43 0 13.86-2.88 13.86-10.37 0-6-5-8.83-9.84-9.57" />
        <path d="M733.58 188.63c-3.95 0-7.7-2.61-7.7-6.83 0-6.76 8.9-6.69 16.06-8 1.13-.2 3-.54 3.55-1.54l.13 5.48c.07 6.77-5.62 10.85-12 10.85l-.04.04zm20.12-1.32c-.427.17-.88.26-1.34.27a2.24 2.24 0 0 1-2.47-2.54v-18.3c0-9.23-6.63-11.11-12.72-11.11-7.89 0-13.59 3.48-14 11.58h4.22c.13-5.62 4-8 9.23-8 5 0 9 1.4 9 7.1 0 3.81-1.94 4.29-5.42 4.69-9.1 1.07-18.54 1.4-18.54 11.11 0 7 5.22 10.11 11.58 10.11 6.63 0 9.64-2.54 12.59-7 .13 3.62.8 6 5.08 6a12.21 12.21 0 0 0 2.2-.18l.55-.73.04-3zM593 172.23l-5.65-1.23c-2.88-.74-7.16-2.08-7.16-5.83 0-4.48 4.41-6 8.16-6 4.82 0 8.84 2.35 9 7.56h4.21c-.27-7.5-5.75-11.11-12.64-11.11-6.1 0-13 2.68-13 9.71 0 5.89 4.15 7.77 9.64 9.24l5.42 1.2c3.81.94 7.56 2.28 7.56 6.29 0 4.82-5.49 6.56-9.44 6.56-5.62 0-9.84-2.95-10.17-8.63h-4.22c.67 8.43 6.16 12.18 14.19 12.18 6.42 0 13.85-2.88 13.85-10.37 0-6-5-8.83-9.84-9.57M815.08 172.23l-5.63-1.23c-2.88-.74-7.16-2.08-7.16-5.83 0-4.48 4.41-6 8.16-6 4.82 0 8.84 2.35 9 7.56h4.22c-.27-7.5-5.76-11.11-12.65-11.11-6.09 0-13 2.68-13 9.71 0 5.89 4.15 7.77 9.64 9.24l5.42 1.2c3.81.94 7.56 2.28 7.56 6.29 0 4.82-5.48 6.56-9.44 6.56-5.62 0-9.84-2.95-10.17-8.63h-4.22c.67 8.43 6.15 12.18 14.19 12.18 6.43 0 13.86-2.88 13.86-10.37 0-6-5-8.83-9.84-9.57M418.73 188.63c-4 0-7.7-2.61-7.7-6.83 0-6.76 8.9-6.69 16.07-8 1.14-.2 3-.54 3.55-1.54l.13 5.48c.07 6.77-5.62 10.85-12 10.85m16.22-3.51v-18.34c0-9.23-6.63-11.11-12.72-11.11-7.9 0-13.59 3.48-14 11.58h4.22c.13-5.62 4-8 9.24-8 5 0 9 1.4 9 7.1 0 3.81-1.94 4.29-5.42 4.69-9.11 1.07-18.54 1.4-18.54 11.11 0 7 5.22 10.11 11.58 10.11 6.63 0 9.64-2.54 12.59-7 .13 3.62.8 6 5.08 6a11.76 11.76 0 0 0 2.75-.27v-3.55c-.427.17-.88.26-1.34.27a2.24 2.24 0 0 1-2.47-2.54M450.22 105c-5.62-1.28-11.25-1.81-11.25-5.56 0-3 4.09-3.55 6.29-3.55 3.35 0 6.36 1 7 4.62h8c-.94-7.7-7.36-10.64-14.46-10.64-6.29 0-14.46 2.35-14.46 9.91 0 7 5.49 9 11.11 10.25 5.62 1.25 11.11 1.73 11.31 5.75.2 4.02-4.81 4.55-7.7 4.55-4.08 0-7.43-1.61-7.83-6h-7.63c.13 8.16 6.63 12 15.33 12 7.16 0 15.46-3 15.46-11.25 0-6.83-5.62-8.83-11.18-10.11M541.55 113.73c0 4.81-5.22 6.56-8.56 6.56-2.68 0-7-1-7-4.42 0-4 3-5.22 6.23-5.76 3.23-.54 7-.54 9.37-2.07l-.04 5.69zm6.5 12.58a19.11 19.11 0 0 0 4.81-.87v-5.29a10.53 10.53 0 0 1-1.87.13c-1.4 0-1.8-.73-1.8-2.61V99.86c0-7.29-7.1-10-13.86-10-7.63 0-15.2 2.61-15.73 11.52h7.63c.33-3.75 3.35-5.49 7.63-5.49 3.08 0 7.16.74 7.16 4.69 0 4.48-4.88 3.88-10.37 4.89-6.43.73-13.32 2.14-13.32 10.78 0 6.76 5.62 10.11 11.85 10.11 4.08 0 9-1.28 12-4.22.6 3.15 2.81 4.22 5.89 4.22l-.02-.05zM380.35 105c.2-5.15 3.81-9.17 9.11-9.17 5.3 0 8.43 4.35 8.7 9.17h-17.81zm9.11-15.2c-10.31 0-16.74 8.44-16.74 18.28 0 10.64 6.09 18.21 16.94 18.21 7.57 0 14-4.22 15.67-11.78h-7.23c-1.34 3.82-4 5.76-8.44 5.76-6.36 0-9.3-4.82-9.3-10.24h25.44c1.28-10.38-5.42-20.22-16.33-20.22l-.01-.01zM397.73 143.38h4.22v6.75h-4.22zM511 188.63c-8.1 0-12.12-7.36-12.12-14.72s4-14.73 12.12-14.73 12.12 7.36 12.12 14.73-4 14.72-12.12 14.72m0-33c-10.57 0-16.33 8.37-16.33 18.28 0 9.91 5.76 18.27 16.33 18.27 10.57 0 16.33-8.37 16.33-18.27s-5.75-18.28-16.33-18.28M787.85 156.64h4.22v34.54h-4.22zM799.54 90.76l-8.43 26.58-8.9-26.58h-8.31l12.59 34.62h8.57l12.38-34.62zM787.85 143.38h4.22v6.75h-4.22zM475.67 188.63c-9 0-12.12-7.56-12.12-14.72 0-7.83 2.81-14.73 12.12-14.73 8 0 11.31 7.56 11.31 14.73 0 7.17-3.28 14.72-11.31 14.72m0-33c-5.56 0-10.37 2.88-12.32 7.56l-.13-6.56h-3.88V204h4.22v-19.39c1.94 5 7 7.56 12.12 7.56 10.51 0 15.53-8.5 15.53-18.27s-5-18.28-15.53-18.28" />
      </svg>
    );
  case 'logo-ua-centered':
    return (
      <svg
        width={getWidth(293, 43, height)}
        height={height}
        viewBox="0 0 293 43"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <path id="a" d="M0 841.89h595.28V0H0z" />
        </defs>
        <g transform="translate(-152 -400)" fill="none" fillRule="evenodd">
          <path
            d="M313.719 410.515c.94 0 1.795-.378 2.414-.99l4.205-5.224a1.568 1.568 0 0 1 1.485-.589c2.755.411 4.689 2.74 4.689 5.554l.002 28.082a5.624 5.624 0 0 1-5.625 5.624h-28.107a5.625 5.625 0 0 1-5.624-5.624l.002-28.082c0-2.814 1.934-5.143 4.69-5.554a1.57 1.57 0 0 1 1.484.589l4.205 5.224c.62.612 1.502.99 2.444.99 1.894 0 3.402-1.536 3.402-3.432l-.002-1.776.004-4.39c0-.338.266-.61.603-.61 3.524.29 6.262 3.176 6.262 6.776 0 1.896 1.57 3.432 3.467 3.432zm-1.271 26.866c-1.47 0-2.741.828-3.458 2.137-.3.527-.867.883-1.517.883h-.654c-.65 0-1.217-.356-1.592-.979a3.82 3.82 0 0 0-3.383-2.04h-8.152a.902.902 0 0 1-.903-.89l.004-10.962c0-.49.364-.916.856-.916h8.195c1.469 0 2.744.826 3.457 2.137.3.527.869.882 1.518.882h.654c.65 0 1.217-.355 1.594-.978a3.815 3.815 0 0 1 3.38-2.04l7.565.003c.49 0 .875.397.875.89l-.01 10.987c0 .49-.412.89-.902.89l-7.527-.004zM157.967 430.773h-1.455v3.824c0 1.021-.406 1.8-1.62 1.8-.788 0-1.261-.42-1.261-1.583v-4.04h-1.453v4.181c0 1.721.738 2.588 2.46 2.588.727 0 1.518-.434 1.874-1.098h.025v.92h1.43v-6.592zM159.242 437.364h1.451v-3.889c0-.968.625-1.733 1.594-1.733.855 0 1.264.446 1.29 1.477v4.145h1.454v-4.525c0-1.48-.908-2.246-2.336-2.246-.867 0-1.617.447-2.053 1.174l-.025-.025v-.969h-1.375v6.591z"
            fill={iconColor}
          />
          <path
            d="M166.344 429.637h1.451v-1.376h-1.451v1.376zm0 7.727h1.451v-6.591h-1.451v6.591zM170.867 437.364h1.633l2.357-6.59h-1.504l-1.607 5.061h-.024l-1.67-5.062h-1.583zM176.615 433.488c.04-.98.727-1.746 1.734-1.746.981 0 1.606.827 1.657 1.746h-3.39zm4.846.957c.24-1.977-1.033-3.853-3.112-3.853-1.964 0-3.187 1.61-3.187 3.484 0 2.025 1.16 3.467 3.224 3.467 1.442 0 2.665-.803 2.985-2.244h-1.377c-.256.727-.766 1.098-1.608 1.098-1.21 0-1.77-.92-1.77-1.952h4.845zM182.313 437.364h1.455v-3.137c0-1.45.79-2.256 1.785-2.256.203 0 .42.04.623.063v-1.4c-.127-.015-.218-.04-.547-.04-.892 0-1.761.752-1.927 1.454h-.026v-1.275h-1.363v6.591zM186.185 435.248c.028 1.557 1.262 2.295 2.92 2.295 1.364 0 2.946-.574 2.946-2.142 0-1.3-1.072-1.683-2.13-1.925-1.07-.242-2.141-.345-2.141-1.058 0-.573.779-.676 1.198-.676.637 0 1.212.193 1.338.88h1.52c-.181-1.467-1.405-2.029-2.756-2.029-1.198 0-2.754.447-2.754 1.887 0 1.34 1.047 1.722 2.118 1.952 1.056.244 2.117.332 2.154 1.096.036.753-.92.869-1.468.869-.779 0-1.413-.307-1.492-1.149h-1.453zM192.939 429.637h1.455v-1.376h-1.455v1.376zm0 7.727h1.455v-6.591h-1.455v6.591zM201.928 428.26h-1.453v3.367h-.026c-.445-.727-1.365-1.034-2.193-1.034-1.44 0-2.855 1.046-2.855 3.432 0 1.976 1.006 3.518 3.086 3.518.828 0 1.658-.317 2.039-1.071h.025v.893h1.377v-9.104zm-5.074 5.879c0-1.186.484-2.397 1.849-2.397 1.12 0 1.823.868 1.823 2.32 0 1.148-.547 2.336-1.848 2.336-1.264 0-1.824-1.124-1.824-2.26zM208.773 432.507c0-1.39-1.35-1.914-2.639-1.914-1.453 0-2.894.498-2.996 2.195h1.453c.065-.715.637-1.046 1.453-1.046.588 0 1.366.14 1.366.893 0 .853-.932.739-1.977.929-1.224.14-2.539.409-2.539 2.054 0 1.288 1.072 1.925 2.258 1.925.78 0 1.71-.242 2.283-.803.113.599.535.803 1.123.803.24 0 .701-.09.916-.167v-1.006c-.152.028-.267.028-.355.028-.27 0-.346-.142-.346-.5v-3.391zm-1.453 2.64c0 .918-.994 1.25-1.633 1.25-.51 0-1.338-.192-1.338-.842 0-.766.563-.995 1.186-1.098.636-.114 1.338-.1 1.785-.395v1.085zM216.295 428.26h-1.455v3.367h-.024c-.445-.727-1.365-1.034-2.193-1.034-1.441 0-2.855 1.046-2.855 3.432 0 1.976 1.007 3.518 3.084 3.518.83 0 1.658-.317 2.04-1.071h.026v.893h1.377v-9.104zm-5.074 5.879c0-1.186.484-2.397 1.849-2.397 1.12 0 1.823.868 1.823 2.32 0 1.148-.55 2.336-1.848 2.336-1.264 0-1.824-1.124-1.824-2.26zM218.754 433.488c.039-.98.729-1.746 1.736-1.746.98 0 1.606.827 1.657 1.746h-3.393zm4.846.957c.242-1.977-1.033-3.853-3.11-3.853-1.965 0-3.19 1.61-3.19 3.484 0 2.025 1.16 3.467 3.227 3.467 1.442 0 2.664-.803 2.985-2.244h-1.377c-.256.727-.766 1.098-1.608 1.098-1.211 0-1.773-.92-1.773-1.952h4.846zM233.95 428.26h-1.454v3.367h-.026c-.447-.727-1.363-1.034-2.19-1.034-1.442 0-2.856 1.046-2.856 3.432 0 1.976 1.005 3.518 3.084 3.518.828 0 1.656-.317 2.04-1.071h.026v.893h1.375v-9.104zm-5.075 5.879c0-1.186.484-2.397 1.847-2.397 1.123 0 1.825.868 1.825 2.32 0 1.148-.549 2.336-1.848 2.336-1.262 0-1.824-1.124-1.824-2.26zM236.41 433.488c.037-.98.727-1.746 1.732-1.746.983 0 1.608.827 1.66 1.746h-3.392zm4.844.957c.244-1.977-1.03-3.853-3.112-3.853-1.962 0-3.185 1.61-3.185 3.484 0 2.025 1.16 3.467 3.226 3.467 1.44 0 2.664-.803 2.983-2.244h-1.379c-.254.727-.764 1.098-1.604 1.098-1.212 0-1.773-.92-1.773-1.952h4.844zM250.916 432.507c0-1.39-1.352-1.914-2.639-1.914-1.453 0-2.894.498-2.998 2.195h1.455c.065-.715.637-1.046 1.453-1.046.586 0 1.364.14 1.364.893 0 .853-.928.739-1.975.929-1.224.14-2.537.409-2.537 2.054 0 1.288 1.07 1.925 2.258 1.925.775 0 1.707-.242 2.279-.803.115.599.537.803 1.123.803.244 0 .701-.09.92-.167v-1.006c-.154.028-.269.028-.357.028-.27 0-.346-.142-.346-.5v-3.391zm-1.453 2.64c0 .918-.994 1.25-1.631 1.25-.512 0-1.34-.192-1.34-.842 0-.766.561-.995 1.186-1.098.638-.114 1.338-.1 1.785-.395v1.085zM253.975 437.364h1.633l2.357-6.59h-1.504l-1.607 5.061h-.024l-1.671-5.062h-1.582zM259.723 433.488c.039-.98.727-1.746 1.734-1.746.98 0 1.606.827 1.657 1.746h-3.391zm4.846.957c.24-1.977-1.033-3.853-3.112-3.853-1.964 0-3.187 1.61-3.187 3.484 0 2.025 1.16 3.467 3.224 3.467 1.442 0 2.665-.803 2.985-2.244h-1.377c-.254.727-.766 1.098-1.608 1.098-1.21 0-1.771-.92-1.771-1.952h4.846zM265.459 429.637h1.453v-1.376h-1.453v1.376zm0 7.727h1.453v-6.591h-1.453v6.591zM268.236 437.364h1.455v-3.137c0-1.45.791-2.256 1.785-2.256.203 0 .42.04.623.063v-1.4c-.127-.015-.217-.04-.547-.04-.892 0-1.759.752-1.925 1.454h-.026v-1.275h-1.365v6.591zM275.26 437.543c2.115 0 3.328-1.453 3.328-3.481 0-2.014-1.213-3.469-3.328-3.469-2.117 0-3.328 1.455-3.328 3.469 0 2.028 1.21 3.481 3.328 3.481m0-1.146c-1.301 0-1.875-1.187-1.875-2.335 0-1.134.574-2.32 1.875-2.32 1.299 0 1.875 1.186 1.875 2.32 0 1.148-.576 2.335-1.875 2.335M337.16 428.847h-.803v1.976h-1.148v.675h1.148v4.5c-.013 1.124.356 1.483 1.426 1.483.244 0 .473-.028.717-.028v-.687a7.012 7.012 0 0 1-.692.039c-.572-.04-.648-.345-.648-.87v-4.437h1.34v-.675h-1.34v-1.976zM339.39 437.402h.804v-3.839c.025-1.286.79-2.257 2.064-2.257 1.3 0 1.67.857 1.67 1.991v4.105h.805v-4.233c0-1.568-.561-2.538-2.41-2.538-.932 0-1.811.535-2.104 1.326h-.025v-3.659h-.803v9.104zM346.465 433.653c.125-1.198.854-2.347 2.168-2.347 1.3 0 2.05 1.137 2.09 2.347h-4.258zm5.06.677c.065-1.85-.775-3.699-2.892-3.699-2.092 0-2.973 1.747-2.973 3.482 0 1.875.88 3.48 2.973 3.48 1.656 0 2.523-.867 2.867-2.359h-.803c-.253.996-.892 1.684-2.064 1.684-1.545 0-2.156-1.415-2.168-2.588h5.06zM355.13 431.307c1.544 0 2.31 1.403 2.31 2.807 0 1.4-.766 2.804-2.31 2.804-1.54 0-2.306-1.403-2.306-2.804 0-1.404.766-2.807 2.307-2.807m0-.676c-2.014 0-3.111 1.596-3.111 3.483 0 1.885 1.097 3.48 3.11 3.48 2.017 0 3.112-1.595 3.112-3.48 0-1.887-1.095-3.483-3.111-3.483M359.185 437.402h.801v-3.506c0-1.364.997-2.435 2.45-2.357v-.805c-1.186-.052-2.078.572-2.486 1.633h-.026v-1.545h-.738v6.58zM362.957 429.585h.805v-1.286h-.805v1.286zm0 7.817h.805v-6.58h-.805v6.58zM365.772 432.839c.026-1.071.767-1.532 1.762-1.532.942 0 1.72.269 1.72 1.352 0 .727-.372.817-1.034.893-1.732.204-3.53.266-3.53 2.117 0 1.326.993 1.925 2.204 1.925 1.264 0 1.837-.484 2.399-1.338h.025c0 .687.127 1.146.942 1.146.219 0 .346-.012.526-.05v-.676a.776.776 0 0 1-.257.05c-.32 0-.472-.178-.472-.483v-3.496c0-1.76-1.262-2.116-2.423-2.116-1.504 0-2.588.664-2.666 2.208h.803zm3.481 2.014c.012 1.286-1.07 2.065-2.296 2.065-.75 0-1.464-.498-1.464-1.3 0-1.288 1.695-1.275 3.06-1.517.214-.04.574-.102.675-.294h.025v1.046zM374.693 439.837h.803v-3.684h.025c.344.944 1.301 1.44 2.283 1.44 2.002 0 2.96-1.616 2.96-3.48 0-1.862-.958-3.482-2.96-3.482-1.058 0-1.976.55-2.345 1.442h-.026v-1.251h-.74v9.015zm5.266-5.724c0 1.364-.625 2.805-2.155 2.805-1.709 0-2.308-1.441-2.308-2.805 0-1.491.535-2.806 2.308-2.806 1.53 0 2.155 1.44 2.155 2.806zM384.537 431.307c1.541 0 2.31 1.403 2.31 2.807 0 1.4-.769 2.804-2.31 2.804-1.545 0-2.309-1.403-2.309-2.804 0-1.404.764-2.807 2.31-2.807m0-.676c-2.015 0-3.112 1.596-3.112 3.483 0 1.885 1.097 3.48 3.111 3.48 2.014 0 3.111-1.595 3.111-3.48 0-1.887-1.097-3.483-3.11-3.483M388.602 429.585h.803v-1.286h-.803v1.286zm0 7.817h.803v-6.58h-.803v6.58zM391.162 433.653c.13-1.198.854-2.347 2.168-2.347 1.301 0 2.051 1.137 2.09 2.347h-4.258zm5.061.677c.064-1.85-.776-3.699-2.893-3.699-2.092 0-2.97 1.747-2.97 3.482 0 1.875.878 3.48 2.97 3.48 1.656 0 2.523-.867 2.867-2.359h-.803c-.253.996-.892 1.684-2.064 1.684-1.545 0-2.154-1.415-2.168-2.588h5.061zM401.793 432.747c-.051-1.427-1.098-2.116-2.41-2.116-1.16 0-2.475.512-2.475 1.85 0 1.122.791 1.48 1.838 1.758l1.033.23c.725.18 1.442.436 1.442 1.2 0 .917-1.047 1.25-1.799 1.25-1.072 0-1.875-.563-1.94-1.646h-.802c.127 1.608 1.172 2.321 2.703 2.321 1.224 0 2.639-.55 2.639-1.976 0-1.149-.956-1.684-1.874-1.825l-1.07-.24c-.551-.14-1.365-.397-1.365-1.11 0-.854.84-1.136 1.557-1.136.916 0 1.681.446 1.718 1.44h.805zM402.941 429.585h.803v-1.286h-.803v1.286zm0 7.817h.803v-6.58h-.803v6.58zM409.772 432.747c-.051-1.427-1.096-2.116-2.41-2.116-1.16 0-2.474.512-2.474 1.85 0 1.122.79 1.48 1.837 1.758l1.03.23c.728.18 1.442.436 1.442 1.2 0 .917-1.046 1.25-1.796 1.25-1.072 0-1.875-.563-1.94-1.646h-.803c.127 1.608 1.172 2.321 2.703 2.321 1.225 0 2.64-.55 2.64-1.976 0-1.149-.956-1.684-1.875-1.825l-1.07-.24c-.55-.14-1.366-.397-1.366-1.11 0-.854.844-1.136 1.557-1.136.917 0 1.683.446 1.72 1.44h.805zM414.193 439.837h.805v-3.684h.025c.344.944 1.301 1.44 2.281 1.44 2.002 0 2.96-1.616 2.96-3.48 0-1.862-.958-3.482-2.96-3.482-1.058 0-1.974.55-2.347 1.442h-.026v-1.251h-.738v9.015zm5.268-5.724c0 1.364-.625 2.805-2.157 2.805-1.709 0-2.306-1.441-2.306-2.805 0-1.491.535-2.806 2.306-2.806 1.532 0 2.157 1.44 2.157 2.806zM421.258 437.402h.8v-3.506c0-1.364.997-2.435 2.45-2.357v-.805c-1.186-.052-2.078.572-2.486 1.633h-.026v-1.545h-.738v6.58zM425.746 432.839c.025-1.071.764-1.532 1.758-1.532.943 0 1.722.269 1.722 1.352 0 .727-.37.817-1.035.893-1.732.204-3.53.266-3.53 2.117 0 1.326.993 1.925 2.204 1.925 1.264 0 1.838-.484 2.4-1.338h.024c0 .687.13 1.146.943 1.146.217 0 .346-.012.524-.05v-.676a.765.765 0 0 1-.256.05c-.318 0-.47-.178-.47-.483v-3.496c0-1.76-1.263-2.116-2.425-2.116-1.504 0-2.588.664-2.664 2.208h.805zm3.48 2.014c.012 1.286-1.072 2.065-2.294 2.065-.754 0-1.467-.498-1.467-1.3 0-1.288 1.695-1.275 3.058-1.517.22-.04.575-.102.678-.294h.025v1.046z"
            fill={iconColor}
            mask="url(#b)"
          />
          <path
            fill={iconColor}
            mask="url(#b)"
            d="M430.625 437.402h.994l2.027-2.768 2.067 2.768h1.019l-2.562-3.43 2.371-3.15h-1.006l-1.836 2.5-1.877-2.5h-1.006l2.36 3.162zM437.268 429.585h.803v-1.286h-.803v1.286zm0 7.817h.803v-6.58h-.803v6.58zM444.1 432.747c-.053-1.427-1.098-2.116-2.41-2.116-1.16 0-2.475.512-2.475 1.85 0 1.122.79 1.48 1.836 1.758l1.033.23c.729.18 1.442.436 1.442 1.2 0 .917-1.045 1.25-1.8 1.25-1.07 0-1.872-.563-1.935-1.646h-.804c.127 1.608 1.174 2.321 2.703 2.321 1.223 0 2.639-.55 2.639-1.976 0-1.149-.958-1.684-1.874-1.825l-1.072-.24c-.547-.14-1.363-.397-1.363-1.11 0-.854.842-1.136 1.555-1.136.918 0 1.68.446 1.722 1.44h.803z"
          />
        </g>
      </svg>
    );
  case 'logo-ua-mobile':
    return (
      <svg
        width={getWidth(616, 220, height)}
        height={height}
        fill={iconColor}
        viewBox="0 0 616 220"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M174.24 186.58a4.63 4.63 0 0 1-4.65 4.57H130.8c-7.57 0-14.13 4.26-17.82 11a9 9 0 0 1-7.81 4.55h-3.37a9.54 9.54 0 0 1-8.21-5 19.66 19.66 0 0 0-17.43-10.51h-42a4.63 4.63 0 0 1-4.65-4.57v-56.5a4.53 4.53 0 0 1 4.38-4.72h42.26c7.57 0 14.14 4.26 17.81 11a9 9 0 0 0 7.83 4.54h3.37a9.54 9.54 0 0 0 8.21-5 19.67 19.67 0 0 1 17.43-10.51h39a4.52 4.52 0 0 1 4.5 4.58l-.06 56.57zm4.88-169a8.08 8.08 0 0 0-7.64 3.03L149.8 47.55A17.83 17.83 0 0 1 119.48 35c.1-18.326-13.987-33.61-32.26-35a3.1 3.1 0 0 0-3.11 3.15v31.78a17.56 17.56 0 0 1-17.55 17.69 18.05 18.05 0 0 1-12.6-5.11L32.3 20.58a8.09 8.09 0 0 0-7.65-3.03C10.45 19.67.49 31.67.49 46.18V191c0 16.016 12.984 29 29 29h144.82c16.016 0 29-12.984 29-29V46.23c0-14.51-10-26.52-24.16-28.63l-.03-.02zM457.49 91.54h7.49v33.96h-7.49zM262.79 186.17c-6.51 0-9.4-5.79-9.4-11.63 0-6.1 2.49-12.35 9.53-12.35 5.77 0 9.39 4.47 9.39 12 0 5.91-2.82 12-9.51 12l-.01-.02zM272 161.6c-2.43-3.74-7.16-5.31-11.43-5.31-7.42 0-14.7 5.38-14.7 17.66 0 10.17 5.18 18.12 15.88 18.12 4.27 0 8.54-1.64 10.51-5.52l.14 4.6h7.09v-46.87H272v17.32zM382.34 96.54c5.06 0 8.28 4.26 8.54 9h-17.47c.19-5.05 3.75-9 8.93-9m.2 29.88c7.42 0 13.72-4.14 15.37-11.56h-7.1c-1.31 3.75-3.94 5.64-8.27 5.64-6.24 0-9.13-4.72-9.13-10h24.95c1.25-10.17-5.32-19.83-16-19.83-10.12 0-16.41 8.27-16.41 17.94 0 10.43 6 17.86 16.61 17.86M410.24 109.34c0-7.48 4.07-11.63 9.19-11.63a26.71 26.71 0 0 1 3.22.34v-7.23a18.37 18.37 0 0 0-2.82-.19c-4.59 0-9.06 3.88-9.92 7.48l-.13-6.56h-7v34h7.49l-.03-16.21zM291.41 105.46c0-5 3.22-8.93 8.22-8.93 4.39 0 6.5 2.3 6.63 7.61v21.36h7.49v-23.32c0-7.62-4.67-11.56-12-11.56a12.17 12.17 0 0 0-10.57 6l-.13-5.12h-7.09v34h7.48l-.03-20.04zM260.22 126.41a11.39 11.39 0 0 0 9.66-5.65l.13 4.73h7.36v-34h-7.49v19.7c0 5.26-2.1 9.26-8.34 9.26-4.08 0-6.5-2.16-6.5-8.14V91.54h-7.48v21.54c0 8.87 3.81 13.33 12.67 13.33M457.49 78.61h7.49v7.09h-7.49zM487.16 96.54c5.77 0 9.39 4.46 9.39 11.95 0 5.92-2.82 12-9.52 12-6.5 0-9.39-5.77-9.39-11.62 0-6.12 2.49-12.34 9.53-12.34M486 126.41c4.27 0 8.54-1.65 10.51-5.51l.13 4.6h7.09V78.61h-7.48v17.34c-2.43-3.75-7.16-5.33-11.43-5.33-7.42 0-14.7 5.39-14.7 17.67 0 10.17 5.18 18.12 15.88 18.12M352.21 125.5l12.14-33.96h-7.74l-8.28 26.07-8.73-26.07h-8.14l12.34 33.96zM476 156.49a18.23 18.23 0 0 0-2.82-.2c-4.6 0-9.06 3.87-9.91 7.48l-.14-6.56h-7v33.95h7.49V175c0-7.48 4.07-11.62 9.19-11.62a25.39 25.39 0 0 1 3.22.33l-.03-7.22zM492.28 186.17c-6.69 0-9.65-6.11-9.65-12s3-12 9.65-12 9.65 6.11 9.65 12-2.95 12-9.65 12m0-29.88c-10.9 0-17.14 7.48-17.14 17.86 0 10.38 6.24 17.93 17.14 17.93s17.14-7.48 17.14-17.93-6.23-17.86-17.14-17.86M292.21 171.19c.19-5.05 3.74-9 8.92-9s8.27 4.27 8.54 9h-17.46zm8.92-14.91c-10.12 0-16.41 8.27-16.41 17.92 0 10.45 6 17.87 16.61 17.87 7.43 0 13.73-4.14 15.37-11.57h-7.1c-1.31 3.75-3.94 5.66-8.28 5.66-6.23 0-9.11-4.73-9.11-10h24.94c1.25-10.18-5.32-19.83-16-19.83l-.02-.05zM441.8 144.27h7.49v7.09h-7.49zM590.43 105.53c.19-5.06 3.74-9 8.93-9 5.19 0 8.27 4.27 8.54 9h-17.47zm8.93-14.91c-10.12 0-16.41 8.27-16.41 17.93 0 10.44 6 17.86 16.61 17.86 7.43 0 13.73-4.14 15.37-11.56h-7.09c-1.31 3.74-3.94 5.64-8.28 5.64-6.23 0-9.12-4.73-9.12-10h24.95c1.25-10.18-5.32-19.83-16-19.83l-.03-.04zM561 120.49c-6.5 0-9.39-5.77-9.39-11.62 0-6.12 2.49-12.34 9.53-12.34 5.77 0 9.38 4.46 9.38 11.95 0 5.92-2.82 12-9.52 12v.01zm9.26-24.56c-2.43-3.75-7.16-5.33-11.43-5.33-7.42 0-14.7 5.39-14.7 17.67 0 10.17 5.18 18.12 15.88 18.12 4.27 0 8.54-1.65 10.51-5.51l.13 4.6h7.09V78.6h-7.48v17.33zM531.54 114.06c0 4.73-5.11 6.43-8.4 6.43-2.63 0-6.89-1-6.89-4.34 0-3.93 2.89-5.11 6.1-5.64 3.21-.53 6.89-.53 9.19-2v5.55zm7.49 3.88v-17.47c0-7.15-7-9.85-13.59-9.85-7.48 0-14.91 2.56-15.44 11.3h7.49c.32-3.68 3.28-5.39 7.49-5.39 3 0 7 .72 7 4.6 0 4.4-4.8 3.81-10.17 4.8-6.31.72-13.07 2.1-13.07 10.57 0 6.63 5.51 9.92 11.62 9.92 4 0 8.8-1.25 11.76-4.14.59 3.09 2.76 4.14 5.77 4.14a18.46 18.46 0 0 0 4.73-.86v-5.18a10.48 10.48 0 0 1-1.84.13c-1.37 0-1.77-.72-1.77-2.56l.02-.01zM441.94 105.46c-5.51-1.25-11-1.78-11-5.45 0-3 4-3.48 6.17-3.48 3.28 0 6.24 1 6.89 4.52h7.81c-.92-7.55-7.23-10.44-14.19-10.44-6.17 0-14.19 2.3-14.19 9.72 0 6.89 5.39 8.86 10.91 10 5.52 1.14 10.9 1.7 11.09 5.64.19 3.94-4.72 4.47-7.55 4.47-4 0-7.29-1.57-7.68-5.91h-7.5c.14 8 6.5 11.83 15 11.83 7 0 15.17-3 15.17-11 0-6.69-5.52-8.66-11-9.91M359.42 179.73c0 4.73-5.12 6.44-8.41 6.44-2.63 0-6.89-1-6.89-4.34 0-3.94 2.89-5.13 6.11-5.65 3.22-.52 6.89-.53 9.19-2v5.55zm7.48 3.87v-17.46c0-7.16-7-9.86-13.59-9.86-7.48 0-14.91 2.56-15.42 11.29h7.48c.33-3.67 3.28-5.38 7.48-5.38 3 0 7 .72 7 4.59 0 4.4-4.8 3.81-10.18 4.8-6.3.72-13.07 2.1-13.07 10.57 0 6.64 5.51 9.92 11.62 9.92 4 0 8.8-1.26 11.76-4.14.59 3.09 2.76 4.14 5.78 4.14a19.13 19.13 0 0 0 4.72-.85V186a10.38 10.38 0 0 1-1.84.13c-1.38 0-1.77-.73-1.77-2.57l.03.04zM320.5 78.61h7.5v7.09h-7.5zM320.5 91.54h7.5v33.96h-7.5zM441.8 157.21h7.49v33.95h-7.49zM387.19 183.28l-8.73-26.07h-8.14l12.34 33.94h8.41l12.14-33.94h-7.74zM412.27 171.19c.19-5.05 3.73-9 8.93-9 5.2 0 8.27 4.27 8.53 9h-17.46zm8.93-14.91c-10.11 0-16.42 8.27-16.42 17.92 0 10.45 6 17.87 16.62 17.87 7.42 0 13.72-4.14 15.36-11.57h-7.09c-1.31 3.75-3.93 5.66-8.27 5.66-6.25 0-9.13-4.73-9.13-10h24.95c1.24-10.18-5.32-19.83-16-19.83l-.02-.05z" />
      </svg>
    );
  case 'people':
    return (
      <svg
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <path
            d="M19.562 11.294a2.46 2.46 0 0 0 1.04-2.007 2.443 2.443 0 0 0-2.437-2.453 2.443 2.443 0 0 0-2.436 2.453c0 .83.41 1.565 1.039 2.007a4.214 4.214 0 0 0-1.44.85 5.45 5.45 0 0 0-1.976-1.084 3.12 3.12 0 0 0 1.49-2.662c0-1.718-1.38-3.108-3.086-3.108-1.705 0-3.086 1.395-3.086 3.108a3.11 3.11 0 0 0 1.49 2.662 5.495 5.495 0 0 0-1.954 1.072 4.248 4.248 0 0 0-1.423-.833A2.46 2.46 0 0 0 7.82 9.29a2.443 2.443 0 0 0-2.436-2.453A2.443 2.443 0 0 0 2.95 9.29c0 .83.41 1.565 1.039 2.008a4.305 4.305 0 0 0-2.88 4.069v.28c0 .01.01.018.018.018h5.163a5.76 5.76 0 0 0-.047.718v.29a2.253 2.253 0 0 0 2.247 2.262h6.543a2.253 2.253 0 0 0 2.246-2.262v-.29a5.76 5.76 0 0 0-.046-.718h5.197c.009 0 .017-.009.017-.017v-.281a4.321 4.321 0 0 0-2.884-4.074zm-3.157-2.011c0-.978.789-1.773 1.76-1.773s1.76.795 1.76 1.773c0 .965-.772 1.752-1.726 1.773h-.068a1.765 1.765 0 0 1-1.726-1.773zm-7.068-.885c0-1.339 1.08-2.428 2.41-2.428s2.411 1.089 2.411 2.428a2.424 2.424 0 0 1-2.27 2.424h-.28a2.424 2.424 0 0 1-2.27-2.424zm-5.725.885c0-.978.79-1.773 1.76-1.773.972 0 1.761.795 1.761 1.773 0 .965-.772 1.752-1.726 1.773h-.068a1.767 1.767 0 0 1-1.727-1.773zm2.795 5.698H1.793c.19-1.811 1.71-3.232 3.554-3.244H5.398c.878.004 1.68.331 2.301.863a5.595 5.595 0 0 0-1.292 2.381zm10.188 1.693c0 .871-.706 1.581-1.571 1.581H8.48c-.865 0-1.57-.71-1.57-1.581v-.29c0-2.64 2.094-4.8 4.698-4.877.047.004.098.004.144.004.046 0 .097 0 .144-.004 2.604.076 4.699 2.237 4.699 4.877v.29zm.502-1.693a5.58 5.58 0 0 0-1.28-2.364 3.572 3.572 0 0 1 2.323-.88h.05c1.845.012 3.365 1.433 3.555 3.244h-4.648z"
            fill={iconColor}
          />
          <path
            d="M19.562 11.294a2.46 2.46 0 0 0 1.04-2.007 2.443 2.443 0 0 0-2.437-2.453 2.443 2.443 0 0 0-2.436 2.453c0 .83.41 1.565 1.039 2.007a4.214 4.214 0 0 0-1.44.85 5.45 5.45 0 0 0-1.976-1.084 3.12 3.12 0 0 0 1.49-2.662c0-1.718-1.38-3.108-3.086-3.108-1.705 0-3.086 1.395-3.086 3.108a3.11 3.11 0 0 0 1.49 2.662 5.495 5.495 0 0 0-1.954 1.072 4.248 4.248 0 0 0-1.423-.833A2.46 2.46 0 0 0 7.82 9.29a2.443 2.443 0 0 0-2.436-2.453A2.443 2.443 0 0 0 2.95 9.29c0 .83.41 1.565 1.039 2.008a4.305 4.305 0 0 0-2.88 4.069v.28c0 .01.01.018.018.018h5.163a5.76 5.76 0 0 0-.047.718v.29a2.253 2.253 0 0 0 2.247 2.262h6.543a2.253 2.253 0 0 0 2.246-2.262v-.29a5.76 5.76 0 0 0-.046-.718h5.197c.009 0 .017-.009.017-.017v-.281a4.321 4.321 0 0 0-2.884-4.074zm-3.157-2.011c0-.978.789-1.773 1.76-1.773s1.76.795 1.76 1.773c0 .965-.772 1.752-1.726 1.773h-.068a1.765 1.765 0 0 1-1.726-1.773zm-7.068-.885c0-1.339 1.08-2.428 2.41-2.428s2.411 1.089 2.411 2.428a2.424 2.424 0 0 1-2.27 2.424h-.28a2.424 2.424 0 0 1-2.27-2.424zm-5.725.885c0-.978.79-1.773 1.76-1.773.972 0 1.761.795 1.761 1.773 0 .965-.772 1.752-1.726 1.773h-.068a1.767 1.767 0 0 1-1.727-1.773zm2.795 5.698H1.793c.19-1.811 1.71-3.232 3.554-3.244H5.398c.878.004 1.68.331 2.301.863a5.595 5.595 0 0 0-1.292 2.381zm10.188 1.693c0 .871-.706 1.581-1.571 1.581H8.48c-.865 0-1.57-.71-1.57-1.581v-.29c0-2.64 2.094-4.8 4.698-4.877.047.004.098.004.144.004.046 0 .097 0 .144-.004 2.604.076 4.699 2.237 4.699 4.877v.29zm.502-1.693a5.58 5.58 0 0 0-1.28-2.364 3.572 3.572 0 0 1 2.323-.88h.05c1.845.012 3.365 1.433 3.555 3.244h-4.648z"
            stroke={iconColor}
            strokeWidth="0.5"
          />
        </g>
      </svg>
    );
  case 'settings':
    return (
      <svg
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h24v24H0z" />
          <path
            d="M22.772 9.48l-1.685-.285a9.512 9.512 0 0 0-.677-1.635l.993-1.388a1.478 1.478 0 0 0-.16-1.91l-1.495-1.495a1.472 1.472 0 0 0-1.905-.16L16.45 3.6a9.413 9.413 0 0 0-1.694-.697l-.28-1.665A1.481 1.481 0 0 0 13.01 0H10.9c-.728 0-1.344.521-1.465 1.238l-.29 1.705a9.277 9.277 0 0 0-1.63.687l-1.378-.993a1.472 1.472 0 0 0-.863-.276c-.396 0-.772.156-1.048.437L2.727 4.292a1.484 1.484 0 0 0-.16 1.91L3.57 7.61a9.29 9.29 0 0 0-.667 1.64l-1.665.28A1.481 1.481 0 0 0 0 10.995v2.11c0 .727.521 1.344 1.238 1.464l1.705.291c.175.562.406 1.108.687 1.63l-.988 1.373a1.478 1.478 0 0 0 .16 1.91l1.495 1.495a1.472 1.472 0 0 0 1.905.16l1.409-1.003a9.484 9.484 0 0 0 1.584.652l.28 1.685c.12.717.738 1.238 1.465 1.238h2.115c.727 0 1.344-.521 1.464-1.238l.286-1.685a9.512 9.512 0 0 0 1.634-.677l1.39.993c.25.18.55.276.862.276.396 0 .767-.156 1.047-.436l1.494-1.495a1.484 1.484 0 0 0 .16-1.91l-.992-1.393a9.444 9.444 0 0 0 .677-1.635l1.685-.28A1.481 1.481 0 0 0 24 13.054v-2.11a1.463 1.463 0 0 0-1.228-1.464zm-.116 3.575a.13.13 0 0 1-.11.13l-2.106.352a.673.673 0 0 0-.541.496 8.026 8.026 0 0 1-.873 2.1.678.678 0 0 0 .03.738l1.239 1.744c.035.05.03.126-.015.17l-1.494 1.495a.127.127 0 0 1-.095.04.123.123 0 0 1-.076-.025l-1.74-1.238a.677.677 0 0 0-.736-.03 8.026 8.026 0 0 1-2.101.872.665.665 0 0 0-.496.541l-.356 2.106a.13.13 0 0 1-.13.11h-2.111a.13.13 0 0 1-.13-.11l-.352-2.106a.673.673 0 0 0-.496-.541 8.334 8.334 0 0 1-2.056-.842.694.694 0 0 0-.34-.09.66.66 0 0 0-.392.125L5.425 20.34a.15.15 0 0 1-.076.025.134.134 0 0 1-.095-.04L3.76 18.831a.136.136 0 0 1-.015-.17l1.233-1.73a.686.686 0 0 0 .03-.742 7.95 7.95 0 0 1-.882-2.096.687.687 0 0 0-.541-.496l-2.121-.361a.13.13 0 0 1-.11-.13v-2.111a.13.13 0 0 1 .11-.13l2.09-.352a.678.678 0 0 0 .547-.5 8.018 8.018 0 0 1 .857-2.107.67.67 0 0 0-.035-.732L3.675 5.42a.137.137 0 0 1 .015-.17l1.494-1.495a.127.127 0 0 1 .095-.04c.03 0 .055.01.075.025l1.73 1.233c.22.156.512.166.742.03a7.95 7.95 0 0 1 2.096-.882.687.687 0 0 0 .496-.541l.361-2.121a.13.13 0 0 1 .13-.11h2.111a.13.13 0 0 1 .13.11l.351 2.09c.046.266.241.482.502.547.757.19 1.479.486 2.15.882.231.136.517.126.738-.03l1.73-1.243a.15.15 0 0 1 .075-.025c.02 0 .06.005.095.04l1.494 1.494c.045.045.05.115.015.17l-1.238 1.74a.677.677 0 0 0-.03.737c.39.657.681 1.364.872 2.101.065.26.28.456.541.496l2.106.356a.13.13 0 0 1 .11.13v2.111h-.005z"
            fill={iconColor}
          />
          <path
            d="M12 7c-2.759 0-5 2.241-5 5s2.241 5 5 5 5-2.241 5-5-2.241-5-5-5zm0 8.693A3.696 3.696 0 0 1 8.307 12 3.696 3.696 0 0 1 12 8.307 3.696 3.696 0 0 1 15.693 12 3.696 3.696 0 0 1 12 15.693z"
            fill={iconColor}
          />
        </g>
      </svg>
    );
  case 'module':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
      >
        <g fill="none" fillRule="evenodd">
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            fill={iconColor}
            fillRule="nonzero"
            d="M19.211 5.777v3.556H5.79V5.777H19.21m0 8.89v3.556H5.79v-3.556H19.21M20.106 4H4.894A.895.895 0 004 4.89v5.333a.895.895 0 00.894.889h15.212a.895.895 0 00.894-.89V4.89A.895.895 0 0020.106 4zm0 8.89H4.894a.895.895 0 00-.894.887v5.334a.895.895 0 00.894.889h15.212a.895.895 0 00.894-.89v-5.333a.895.895 0 00-.894-.888z"
          />
        </g>
      </svg>
    );
  case 'drag-handle':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 24 24"
        width={getWidth(24, 24, height)}
        height={height}
      >
        <defs>
          <path id="a" d="M0 0h24v24H0V0z" />
        </defs>
        <clipPath id="b">
          <use overflow="visible" xlinkHref="#a" />
        </clipPath>
        <path fill={iconColor} d="M20 9H4v2h16V9zM4 15h16v-2H4v2z" clipPath="url(#b)" />
      </svg>
    );
  case 'more-vert':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 24 24"
        width={getWidth(24, 24, height)}
        height={height}
      >
        <path fill="none" d="M0 0h24v24H0z" />
        <path
          fill={iconColor}
          d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
        />
      </svg>
    );
  case 'more-horiz':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M0 0h24v24H0z" />
        <path
          fill={iconColor}
          d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
        />
      </svg>
    )
  case 'delete':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 24 24"
        width={getWidth(24, 24, height)}
        height={height}
      >
        <path
          fill={iconColor}
          d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
        />
        <path fill="none" d="M0 0h24v24H0z" />
      </svg>
    );
  case 'duplicate':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 24 24"
        width={getWidth(24, 24, height)}
        height={height}
      >
        <path fill="none" d="M0 0h24v24H0z" />
        <path
          fill={iconColor}
          d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4l6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2h7zm-1 7h5.5L14 6.5V12z"
        />
      </svg>
    );
  case 'add_photo':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={getWidth(24, 24, height)}
        height={height}
      >
        <path
          fill={iconColor}
          d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z"
        />
        <path fill="none" d="M0 0h24v24H0z" />
      </svg>
    );
  case 'check_circle':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
      >
        <path fill="none" d="M0 0h24v24H0z" />
        <path
          fill={iconColor}
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
        />
      </svg>
    );
  case 'cancel':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
      >
        <path
          fill={iconColor}
          d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
        />
        <path fill="none" d="M0 0h24v24H0z" />
      </svg>
    );
  case 'warn':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M0 0h24v24H0z" />
        <path
          fill={iconColor}
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
        />
      </svg>
    );
  case 'info':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M0 0h24v24H0z" />
        <path
          fill={iconColor}
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
        />
      </svg>
    );
  case 'eye':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M0 0h24v24H0z" />
        <path fill={iconColor} d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
      </svg>
    );
  case 'gallery':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
      >
        <g fill="none" fillRule="evenodd">
          <path
            fill={iconColor}
            fillRule="nonzero"
            d="M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
          />
        </g>
      </svg>
    )
  case 'code':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path fill={iconColor} d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z" />
      </svg>
    )
  case 'tablet':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
      >
        <path
          fill={iconColor}
          fillRule="nonzero"
          d="M17.143 5.75v10H6.857v-10h10.286m.804-1.25H6.053a.477.477 0 00-.482.469V16.53a.478.478 0 00.482.469h11.894c.265 0 .48-.21.482-.469V4.97a.477.477 0 00-.482-.469zM19.072 2H4.928C3.863 2 3 2.84 3 3.874v16.252c0 1.035.863 1.873 1.928 1.874H19.07c1.065 0 1.928-.839 1.929-1.874V3.874C21 2.84 20.137 2.001 19.072 2zm.644 18.126a.636.636 0 01-.642.625H4.928a.636.636 0 01-.642-.624V3.874a.636.636 0 01.642-.624H19.07c.354 0 .642.28.643.624l.002 16.252zM12 17.626c-.52 0-.989.303-1.188.77-.2.467-.09 1.005.277 1.363.368.358.921.465 1.402.272.48-.194.794-.65.794-1.155 0-.332-.135-.65-.376-.885a1.303 1.303 0 00-.91-.365H12z"
        />
      </svg>
    )
  case 'mobile':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
      >
        <path
          fill={iconColor}
          fillRule="nonzero"
          d="M13.8 18.25c0 .69-.582 1.25-1.3 1.25-.718 0-1.3-.56-1.3-1.25S11.782 17 12.5 17c.345 0 .676.131.92.366.244.234.38.552.38.884zM19 3.876v16.25c0 1.035-.873 1.873-1.95 1.874h-9.1C6.875 22 6 21.161 6 20.126V3.876C6 2.84 6.873 2 7.95 2h9.1C18.129 2 19 2.84 19 3.876zm-1.3 0a.64.64 0 00-.65-.626h-9.1a.64.64 0 00-.649.626v16.25a.64.64 0 00.651.625h9.099a.64.64 0 00.65-.624L17.7 3.876z"
        />
      </svg>
    )
  case 'desktop':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
      >
        <path
          fill={iconColor}
          fillRule="nonzero"
          d="M21.167 2H2.833C1.82 2 1 2.84 1 3.874v11.252c0 1.035.82 1.873 1.833 1.874h7.333l-.916 3.75H6.5a.618.618 0 00-.61.625c0 .345.273.625.61.625h11c.338 0 .612-.28.612-.625a.618.618 0 00-.611-.625h-2.75L13.832 17h7.333c1.012 0 1.833-.839 1.834-1.874V3.874C23 2.84 22.18 2.001 21.167 2zM10.511 20.75l.61-2.5h1.752l.61 2.5h-2.972zm11.267-5.626a.62.62 0 01-.61.626H2.832a.62.62 0 01-.61-.624V3.874a.62.62 0 01.61-.624h18.334c.337 0 .61.28.612.624l-.001 11.25z"
        />
      </svg>
    )
  case 'locker':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M0 0h24v24H0z" />
        <path
          fill={iconColor}
          d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
        />
      </svg>
    )
  case 'user':
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={getWidth(24, 24, height)}
        height={height}
        viewBox="0 0 24 24"
      >
        <path fill="none" d="M0 0h24v24H0z" />
        <path
          fill={iconColor}
          d="M12 3.25A4.375 4.375 0 1112 12a4.375 4.375 0 010-8.75m5 12.5a3.756 3.756 0 013.75 3.75v1.25H3.25V19.5A3.756 3.756 0 017 15.75c3.32 0 2.629.625 5 .625 2.379 0 1.676-.625 5-.625M12 2a5.625 5.625 0 100 11.25A5.625 5.625 0 0012 2zm5 12.5c-3.61 0-2.773.625-5 .625-2.219 0-1.395-.625-5-.625a5 5 0 00-5 5v1.25c0 .69.56 1.25 1.25 1.25h17.5c.69 0 1.25-.56 1.25-1.25V19.5a5 5 0 00-5-5z"
        />
      </svg>
    )
  default:
    return 'Invalid Icon';
  }
};

Icon.propTypes = {
  icon: iconType.isRequired,
  color: PropTypes.string,
  height: PropTypes.number,
  modifiers: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
};

Icon.defaultProps = {
  color: null,
  height: 24,
  modifiers: [],
};

export default withTheme(Icon);
